/**
 * Token 管理工具
 */

const TOKEN_KEY = 'xtool_token';
const USER_KEY = 'xtool_user';

/**
 * 获取 Token
 * @returns {string|null}
 */
export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}

/**
 * 设置 Token
 * @param {string} token - JWT Token
 */
export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

/**
 * 移除 Token
 */
export function removeToken() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
}

/**
 * 获取用户信息
 * @returns {object|null}
 */
export function getUser() {
    const userStr = localStorage.getItem(USER_KEY);
    if (userStr) {
        try {
            return JSON.parse(userStr);
        } catch (e) {
            return null;
        }
    }
    return null;
}

/**
 * 设置用户信息
 * @param {object} user - 用户信息
 */
export function setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
}

/**
 * 检查是否已登录
 * @returns {boolean}
 */
export function isAuthenticated() {
    return !!getToken();
}

/**
 * 清除所有认证信息
 */
export function clearAuth() {
    removeToken();
}
